// src\constants\header.constants.js
export const TITLE = 'Mihir Shah';
export const NAV_MENU = [
  { text: 'Home', id: 'home' },
  { text: 'About', id: 'about' },
  { text: 'Skills', id: 'skills' },
  { text: 'Contact', id: 'contact' },
];
